import { render } from "./SystemModuleSetupComponent.vue?vue&type=template&id=546101a2&scoped=true"
import script from "./SystemModuleSetupComponent.vue?vue&type=script&lang=js"
export * from "./SystemModuleSetupComponent.vue?vue&type=script&lang=js"

import "./SystemModuleSetupComponent.vue?vue&type=style&index=0&id=546101a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546101a2"]])

export default __exports__